import React from 'react';
import PublicLayout from './PublicLayout';

const PublicRoute = ({ children }) => {
  return (
    <PublicLayout>
      {children}
    </PublicLayout>
  );
}

export { PublicRoute };